import { render, staticRenderFns } from "./CandidateItemHoldSwitcher.vue?vue&type=template&id=4449e744&scoped=true&lang=pug"
import script from "./CandidateItemHoldSwitcher.vue?vue&type=script&lang=js"
export * from "./CandidateItemHoldSwitcher.vue?vue&type=script&lang=js"
import style0 from "./CandidateItemHoldSwitcher.vue?vue&type=style&index=0&id=4449e744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4449e744",
  null
  
)

export default component.exports